import { Injectable, inject } from '@angular/core';
import { TCalConsumerError } from '@calsale/scanovate';
import { IRemoteError, ISeverityHandler, SeverityHandler, TSeverityCallback, TSeverityCode } from '@partners/errors';
import { NavigationService } from '@partners/navigation';
import { SettingsMap, TAlertFeature } from '@partners/settings';
import { EMPTY } from 'rxjs';
import { NavigationAdapter } from '../../../navigation/services/navigation-adapter.service';
import { PolicyService } from '../../../process/services/policy.service';
import { TScanProcessError } from './scan-errors.types';

@Injectable({
  providedIn: 'root'
})
export class ScanSeverities extends SeverityHandler implements ISeverityHandler {
  override handlers: Map<TSeverityCode, TSeverityCallback>;
  /**An errors from the actual scan process returned to us from scanovate iframe. */
  scanErrorHandlers: Map<TScanProcessError | TCalConsumerError, () => {}>;
  private _navAdapter = inject(NavigationAdapter);
  private _navService = inject(NavigationService);
  private _policyService = inject(PolicyService);

  constructor() {
    super();
    this.scanErrorHandlers = new Map<TScanProcessError | TCalConsumerError, () => {}>()
      //*Token not provided
      .set(1005, () => {
        const { name } = SettingsMap.identity();
        this._navAdapter.moveTo(name);
        return EMPTY;
      })
      //*Invalid token
      .set(1006, () => {
        const { name } = SettingsMap.identity();
        this._navAdapter.moveTo(name);
        return EMPTY;
      })
      //* 'CameraNoRelevantDeviceFound' 1108
      .set(1108, () => {
        //should navigate to identity.
        const { name } = SettingsMap.identity();
        this._navAdapter.moveTo(name);
        return EMPTY;
      })
      .set('unsupportedDocument', () => {
        this._navAdapter.moveBack();
        return EMPTY;
      })
      //*timeout
      .set(2009, () => {
        const { name } = SettingsMap.failedScanAttemptAlert();
        this._navAdapter.toAlert(name as TAlertFeature);
        return EMPTY;
      })
      //*timeout
      .set(1110, () => {
        const { name } = SettingsMap.failedScanAttemptAlert();
        this._navAdapter.toAlert(name as TAlertFeature);
        return EMPTY;
      })
      //*"UserCanceled"
      .set(1105, () => {
        this._navAdapter.moveBack();
        return EMPTY;
      })

      //*an unknown error from scan process.
      //Legacy Errors
      //   .set('unknown', () => {
      //     const { name } = SettingsMap.failedScanAttemptAlert();
      //     this._navAdapter.toAlert(name as TAlertFeature);
      //     return EMPTY;
      //   });

      // this.handlers = new Map<TSeverityCode, TSeverityCallback>()
      //   .set('W_0711', (error: IRemoteError) => {
      //     const { name } = SettingsMap.failedScanAttemptAlert();
      //     this._navAdapter.toAlert(name as TAlertFeature);
      //     return EMPTY;
      //   })
      //End of legacy Errors

      //Cloud version errors
      .set('unknown', () => {
        const { name } = SettingsMap.issue();
        this._navAdapter.moveTo(name);
        return EMPTY;
      });

    this.handlers = new Map<TSeverityCode, TSeverityCallback>()

      .set('W_0711', (error: IRemoteError) => {
        this.updateScanConfig(error);
        const { name } = SettingsMap.scanIntro();
        this._navAdapter.navigateAfterScan(name as TAlertFeature).subscribe();
        return EMPTY;
      })
      //End of cloud version errors

      .set('W_0712', (error: IRemoteError) => {
        //navigate to message/202
        const { name } = SettingsMap.oldIdentificationCardAlert();
        this._navAdapter.toAlert(name as TAlertFeature);
        return EMPTY;
      })
      .set('W_0563', (error: IRemoteError) => {
        //navigate to message/0 in sigma legacy
        const { path } = SettingsMap.genericAlert();
        this._navService.moveAny(`/${path}/${error.token}`);
        return EMPTY;
      })
      .set('W_0241', (error: IRemoteError) => {
        //navigate to message/110
        const { name } = SettingsMap.cardQuotaAlert();
        this._navAdapter.toAlert(name as TAlertFeature);
        return EMPTY;
      })
      .set('W_0028', (error: IRemoteError) => {
        //navigate to message/204 in old sigma
        const { name } = SettingsMap.oldIdentificationCardAlert();
        this._navAdapter.toAlert(name as TAlertFeature);
        return EMPTY;
      })
      .set('W_0859', (error: IRemoteError) => {
        const { name } = SettingsMap.scanValidateAlert();
        this._navAdapter.toAlert(name as TAlertFeature);
        return EMPTY;
      });
  }

  protected updateScanConfig(error: IRemoteError) {
    const result = error?.response?.result;
    if (!result) {
      return;
    }
    const config = { indication: { isMaxAttemptsExceeded: result['isMaxAttemptsExceeded'] } };
    this._policyService.updateFeatureConfig(SettingsMap.scanIntro().name, config);
  }
}
